import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { AdmissionPacketSection } from "@/components/app/admission-packet/packet/packet-section";
import { MedicalRecordsPanel } from "@/components/app/hnp/medical-records-panel";
import { orpc } from "@/lib/orpc";
import { useCan } from "@/lib/policy";

export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/medical-records")(
  { component: MedicalRecordsTab },
);

function MedicalRecordsTab() {
  const { residentId } = Route.useParams();
  const { data: resident } = useSuspenseQuery(
    orpc.care.residents.get.queryOptions({ input: { residentId } }),
  );
  const canWrite = useCan("resident.clinical:update", resident.facilityId);
  const canManagePackets = useCan("admission:manage", resident.facilityId);

  return (
    <>
      {/* The panel titles its sections at h3; this is the tab's own level. */}
      <h2 className="sr-only">History and physical, and medical records</h2>
      <MedicalRecordsPanel
        entity={{ entityType: "resident", entityId: residentId }}
        facilityId={resident.facilityId}
        canWrite={canWrite}
        releaseForms={
          <AdmissionPacketSection
            residentId={residentId}
            facilityId={resident.facilityId}
            canWrite={canManagePackets}
            packetType="medical_release"
            title="Release authorization forms"
            description="Create the authorization, then send it for signature by the resident or family contact, in person or by signing link."
          />
        }
      />
    </>
  );
}
